<template>
  <div id="pageItemList">
    <page-header></page-header>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                :placeholder="$t('fulltextSearch')"
                v-model="searchInput"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="spareParts"
                :rows-per-page-items="[10, 25, 50]"
                :pagination.sync="pagination"
                :total-items="sparePartsCount"
                :loading="sparePartIsLoading"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>
                    <au-vehicle :vehicle="props.item.vehicle" />
                  </td>
                  <td>{{ props.item.type.name }}</td>
                  <td>{{ props.item.serial_number }}</td>
                  <td>{{ $t("sparePartStatus." + props.item.status) }}</td>
                  <td>
                    <v-btn
                      flat
                      icon
                      color="primary"
                      @click="showAction(props.item.id)"
                    >
                      <v-icon>details</v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      icon
                      color="info"
                      @click="editAction(props.item.id)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      icon
                      color="red"
                      @click="$refs.deleteDialog.deleteAction(props.item)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <spare-parts-create-edit-dialog
      v-model="modal"
      @saved="fetchItems"
    ></spare-parts-create-edit-dialog>

    <component :is="dialogComponent" v-model="modalShow" />

    <delete-dialog
      messageKey="deleteSparePart"
      itemKey="serial_number"
      ref="deleteDialog"
      @confirm="deleteConfirmation"
    ></delete-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_SPARE_PARTS,
  FETCH_SPARE_PART,
  DELETE_SPARE_PART,
  SHOW_SNACKBAR
} from "@/store/actions.type";
import refreshButtonMixin from "@/mixins/refreshButton.mixin";
import createButtonMixin from "@/mixins/createButton.mixin";
import searchInputMixin from "@/mixins/searchInput.mixin";
import paginationMixin from "@/mixins/pagination.mixin";
import SparePartsCreateEditDialog from "@/views/SparePart/SparePartsCreateEditDialog.vue";
import SparePartsShowDialog from "@/views/SparePart/SparePartsShowDialog.vue";

export default {
  components: {
    "spare-parts-create-edit-dialog": SparePartsCreateEditDialog,
    "spare-parts-show-dialog": SparePartsShowDialog
  },
  data() {
    return {
      dialogComponent: "",
      pagination: {
        sortBy: "vehicle",
        descending: false
      },
      modal: {
        show: false,
        mode: ""
      },
      modalShow: false,
      headers: [
        { text: "#", value: "id" },
        { text: this.$t("vehicle"), value: "vehicle" },
        { text: this.$t("type"), value: "type" },
        { text: this.$t("serialNumber"), value: "serial_number" },
        { text: this.$t("status"), value: "status" },
        { text: this.$t("actions"), sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "spareParts",
      "sparePart",
      "sparePartsCount",
      "sparePartIsLoading",
      "createButton",
      "refreshButton"
    ])
  },
  mixins: [
    refreshButtonMixin,
    createButtonMixin,
    searchInputMixin,
    paginationMixin
  ],
  watch: {
    modalShow: function(val) {
      if (val) {
        this.dialogComponent = "spare-parts-show-dialog";
      } else {
        this.dialogComponent = "";
      }
    }
  },
  methods: {
    fetchItems() {
      this.$store.dispatch(FETCH_SPARE_PARTS, [this.pagination, this.search]);
    },
    createAction() {
      this.modal.mode = "create";
      this.modal.show = true;
    },
    editAction(id) {
      this.$store.dispatch(FETCH_SPARE_PART, id).then(() => {
        this.modal.mode = "edit";
        this.modal.show = true;
      });
    },
    showAction(id) {
      this.$store.dispatch(FETCH_SPARE_PART, id).then(() => {
        this.modalShow = true;
      });
    },
    deleteConfirmation(sparePart) {
      this.$store.dispatch(DELETE_SPARE_PART, sparePart.id).then(() => {
        this.$store.dispatch(SHOW_SNACKBAR, {
          text: this.$t("deletedSuccessfully", [this.$t("sparePart")]),
          color: "success"
        });

        this.fetchItems();
      });
    }
  }
};
</script>

<style scoped></style>
